import Vue from 'vue'
import Vuex from 'vuex'
import Axios from 'axios'
import api from './variables/routes'

Vue.use(Vuex)

const ajaxCall = ({ commit, state }, data) => {
  data.headers = {}
  if (data.token) {
    data.headers.Authorization = `Bearer ${data.token}`
  }

  return new Promise((resolve, reject) => {
    // { url: auth_check_url, method: 'GET' }
    Axios(data).then(response => {
      resolve(response)
    }).catch(error => {
      if (error.response.status === 403 || error.response.status === 401) {
        commit('logout')
        return
      }
      reject(error)
    })
  })
}

const saveUserProfile = (state, data) => {
  state.user = data.user
  localStorage.setItem('user', JSON.stringify(data.user))
}

const checkAuth = (state) => {
  state.access_token = localStorage.getItem('access_token')
  state.authenticated = state.access_token && state.access_token.length > 0
}

const loadUserProfile = (state) => {
  if (localStorage.getItem('user')) {
    state.user = JSON.parse(localStorage.getItem('user'))
  }
}

const setAuthentication = (state, data) => {
  if (data !== null) { // if status is set then set the status . (should check if the status is boolean)
    state.authenticated = data.status
    state.access_token = data.access_token
  } else {
    state.authenticated = false
    state.access_token = null
  }
}

const login = (state, credentials) => {
  Axios.defaults.headers.common.Authorization = ''
  return new Promise((resolve, reject) => {
    Axios(
      {
        url: credentials.url,
        data: credentials.data,
        method: 'POST'
        // headers: { api_token: state.api_token }
      }).then(response => {
      resolve(response)
    }).catch(err => {
      reject(err)
    })
  })
}

const setToken = ({ commit }, data) => {
  if (!data.access_token) return
  commit('setAuthentication', { status: true, access_token: data.access_token })
  Axios.defaults.headers.common.Authorization = `Bearer ${data.access_token}`
  localStorage.setItem('access_token', data.access_token)
}

const logout = (state) => {
  state.words.loading = false
  state.words.data = []
  state.words.page = 1
  state.authenticated = false
  state.access_token = null
  localStorage.removeItem('access_token')
}

export default new Vuex.Store({
  state: {
    authenticated: false,
    access_token: null,
    api_token: 'R4n5emw9C9myrn4dd6PcOHrRL6rXePMJCwN7LXwrmn9bPRrT1ulnCFWPwnK0',
    words: {
      loading: false,
      data: [],
      page: 1,
      pervs_page: 0,
      total_pages: 1,
      per_page: 150
    },
    api: api,
    user: {
      id: 0,
      name: null,
      email: null,
      email_verified_at: null,
      api_token: null,
      created_at: null,
      updated_at: null
    }
  },
  mutations: {
    setAuthentication,
    logout,
    checkAuth,
    loadUserProfile,
    saveUserProfile
  },
  actions: {
    ajaxCall,
    login,
    setToken
  },
  modules: {}
})
